import React from "react";
import { string, func } from "prop-types";
import { InputGroup, FormControl } from "react-bootstrap";
import FontAwesome from "react-fontawesome";

const SearchBar = ({ placeholder, value, onChange, height }) => (
  <InputGroup style={{ height }}>
    <InputGroup.Prepend>
      <InputGroup.Text
        style={{
          backgroundColor: "white",
        }}
      >
        <FontAwesome name="search" />
      </InputGroup.Text>
    </InputGroup.Prepend>
    <FormControl
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="search-input-component"
    />
  </InputGroup>
);

SearchBar.propTypes = {
  placeholder: string,
  value: string,
  onChange: func,
  height: string,
};

export default SearchBar;
